<template>
  <div class="createpackage">
    <NavBar></NavBar>
    <h1>Add New Contract</h1>
    <CompAddContract></CompAddContract>
    <UserCheck></UserCheck>

    <Footer></Footer>
  </div>
</template>

<script>
// @ is an alias to /src
import NavBar from "@/components/NavBar.vue";
import Footer from "@/components/Footer.vue";
import CompAddContract from "@/components/CompAddContract.vue";
import UserCheck from "@/components/CompUserCheck.vue";

export default {
  name: "CreatePackage",
  components: {
    NavBar,
    CompAddContract,
    UserCheck,
    Footer
  }
};
</script>

<style>
h1 {
  margin-bottom: 15px;
}
</style>
